import View from "../nav/views/TwoHoursDeliveryPromiseButtonView";
import components from "./components.js";
components.define("js-ProductStimulusChrono", View);